import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { SlideTitle, SlideText } from 'johari/ui/atoms';
import Traits from 'johari/ui/components/Traits';
import { MAX_TRAITS } from 'johari/api/constants';

const JohariPageSlide2 = ({
  nextSlide,
  toggleTrait,
  traits = [],
  traitsLength,
  user,
  scrollToButton,
}) => {
  const { t } = useTranslation();
  const { gender } = user || {};

  useEffect(() => {
    if (traits.length >= MAX_TRAITS) {
      scrollToButton();
    }
  }, [traits]);

  return (
    <>
      <SlideTitle>{t('slide2Title')}</SlideTitle>
      <SlideText>
        {t(`slide2Text${gender === 'FEMALE' ? 'Female' : ''}`)}
      </SlideText>
      <CountText>
        {traits.length} из {MAX_TRAITS}
      </CountText>
      <div>
        <Traits toggleTrait={toggleTrait} gender={gender} traits={traits} />
      </div>
    </>
  );
};

const CountText = styled(SlideText)`
  margin-top: 16px;
  margin-bottom: 60px;
  ${(p) => p.theme.max('sm')`
    margin-bottom: 25px;
  `};
  color: ${(p) => p.theme.colors.gray.regular};
`;

JohariPageSlide2.propTypes = {
  nextSlide: PropTypes.func,
  toggleTrait: PropTypes.func,
  traits: PropTypes.arrayOf(PropTypes.string),
  traitsLength: PropTypes.number,
  user: PropTypes.object,
  scrollToButton: PropTypes.func,
};

export default JohariPageSlide2;
